'use strict';
var UnauthorizedPractitionerErrorController = /** @class */ (function () {
    /*@ngInject*/
    function UnauthorizedPractitionerErrorController() {
        this.isAuthenticatedClinicalResourcesPage = function () {
            return this.pagetype == 'clinicalResources_l1' && this.value.loggedInAs == 'Practitioner';
        };
        this.isAuthenticatedAsPatientOnClinicalResourcesPage = function () {
            return this.pagetype == 'clinicalResources_l1' && this.value.loggedInAs == 'Patient';
        };
        this.isPracticeMangementPage = function () {
            return this.pagetype == 'practiceManagement_l1';
        };
    }
    return UnauthorizedPractitionerErrorController;
}());
export default UnauthorizedPractitionerErrorController;
//# sourceMappingURL=unauthorized-practitioner-error.controller.js.map